import { useSelector } from 'react-redux';
import { getCrmOrgById } from '../components/pages/environments/environmentsReducer';
import { useMemo } from 'react';
import { selectDefaultCreationCrmOrgId } from '../reducers/userInfoReducer';

export const useIsSetupCompleted = (crmOrgId?: string) => {
  const defaultCrmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const crmOrg = useSelector(getCrmOrgById(crmOrgId ?? defaultCrmOrgId ?? ''));

  const isManagedPackageInstalled = crmOrg?.isManagedPackageInstalled;
  const isPermissionSetGroupAssigned = crmOrg?.isPermissionSetGroupAssigned;
  const isSetCompleted = useMemo(() => {
    return isManagedPackageInstalled && isPermissionSetGroupAssigned;
  }, [isManagedPackageInstalled, isPermissionSetGroupAssigned]);
  return !!isSetCompleted;
};
